exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#servers-container .img-responsive {\n  max-width: 100%;\n  height: auto;\n}\n", ""]);

